import React from 'react';

const Link = ({ href, children }) => (
	<a href={href} target="_target" style={{ textDecoration: 'none' }}>
		{children}
	</a>
);
export default Link;
